import request from '../../../axios';

export const getWantedPromotedRequirement = async (guid?: string) => {
  const {data}: {data: Array<IUserPromotedAdverstismentData>} =
    await request.get(`/api/v2/wanted/user-promoted-requirement/${guid}`);
  return data;
};
